import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=fafc0030&"
import script from "./headline.vue?vue&type=script&lang=ts&"
export * from "./headline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fafc0030')) {
      api.createRecord('fafc0030', component.options)
    } else {
      api.reload('fafc0030', component.options)
    }
    module.hot.accept("./headline.vue?vue&type=template&id=fafc0030&", function () {
      api.rerender('fafc0030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/guide/headline.vue"
export default component.exports